import React from 'react';
import './Header.css';

const Separator = ({ wide }) => (
    <div className={`header-separator ${wide ? 'header-separator--wide' : 'header-separator--narrow'}`} />
);

export default Separator;
